import {Grid} from "semantic-ui-react";
import PropTypes from "prop-types";


function Rij (props) {
    return (
        <Grid.Row>
            <Grid.Column width={10} style={{maxWidth: '80%'}}>
                {props.children}
            </Grid.Column>
        </Grid.Row>
    )
}

Rij.propTypes = {
    header: PropTypes.string.isRequired, // The header must be a string
    children: PropTypes.node.isRequired // The children must be passable React content
};

export default Rij;